import Swiper, { Controller, Parallax } from 'swiper'
import gsap from 'gsap'

Swiper.use([Controller, Parallax])

export default function () {
  const sections = document.querySelectorAll('.slider-parallax-section')

  sections.forEach(section => {
    const slideCurrentElement = section.querySelector(
      '.slider-parallax-count__current'
    )
    const slideAllElement = section.querySelector('.slider-parallax-count__all')
    const cursor = document.querySelector('.slider-cursor')

    const slider = new Swiper(
      section.querySelector('.slider-parallax-slider'),
      {
        slidesPerView: 1,
        watchOverflow: true,
        parallax: true,
        speed: 800,
        threshold: 0.2,
        on: {
          init(swiper) {
            slideCurrentElement.innerHTML = swiper.activeIndex + 1
            slideAllElement.innerHTML = swiper.slides.length

            gsap.to(section.querySelector('.slider-parallax-count-wrapp'), {
              opacity: 1,
              duration: 0.5,
            })
          },

          touchStart() {
            cursor.classList.add('drag')
          },
          touchEnd() {
            cursor.classList.remove('drag')
          },

          slideChange(swiper) {
            slideCurrentElement.innerHTML = swiper.activeIndex + 1
          },
        },
      }
    )

    if (slider.slides.length <= 1) {
      section.querySelector('.slider-parallax-count-wrapp').style.display =
        'none'
    }
  })
}
